import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import ApiConfig from 'src/config/api-config';
import toast from 'react-hot-toast';

export interface ArchiveProgramPlanPayload {
  docPath?: string;
  programId?: string;
  trainerId?: string;
  isActive?: string;
}

export const useArchiveProgramPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ArchiveProgramPlanPayload) => {
      const response = await axios.post(
        `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_ARCHIVE_PROGRAM_PLAN}`,
        { data: payload },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    },
    onSuccess: (_, variables) => {
      // Invalidate the query to fetch fresh data
      queryClient.invalidateQueries({ queryKey: ['trainer-program-plan-list'] });
      queryClient.invalidateQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientProgramTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientOverview'] });
      queryClient.invalidateQueries({ queryKey: ['overview'] });
      queryClient.invalidateQueries({ queryKey: ['trainer_get_client_overview'] });
      queryClient.removeQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.removeQueries({ queryKey: ['clientProgramTab'] });
      queryClient.removeQueries({ queryKey: ['clientOverview'] });

      const isUnarchiving = variables.isActive === '1';
      toast.success(`Program ${isUnarchiving ? 'restored' : 'archived'} successfully`);
    },
    onError: (error, variables) => {
      const isUnarchiving = variables.isActive === '1';
      const action = isUnarchiving ? 'unarchive' : 'archive';
      console.error(`Failed to ${action} program`, error);
      toast.error(`Failed to ${action} program`);
    },
  });
};
